/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import qs from 'qs';
import {
  Table,
  Pagination,
  Select,
  Input,
  Tooltip,
  Dropdown,
  Menu,
  message,
} from 'antd';
import {
  SearchOutlined,
  MoreOutlined,
  DeleteOutlined,
  UserOutlined,
  DollarOutlined,
  CrownOutlined,
  InfoCircleOutlined,
  CopyOutlined,
} from '@ant-design/icons';
import debounce from 'lodash.debounce';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import {
  listWorkspaces,
  listWorkspacesV2,
  resolveWorkspacesV2Filter,
  countWorkspaces,
  countWorkspacesV2,
  getStats,
  deleteWorkspace,
  grantFreePlan,
  countSeats,
} from '../../services/Admin';
import { dateFromMongoId } from '../../utils/mongo-id';
import { COMPETITOR, APP } from '../../services/Constants';
import ConfirmModal from '../../components/ConfirmModal';
import PlatformLogo from '../../components/PlatformLogo';
import divMaxWidth from '../../utils/divMaxWidth';
import subscriptionCancelAt from '../../utils/subscription';
import CancelingSign from '../../components/CancelingSign';

function Workspaces({ match }) {
  // Pagination
  const location = useLocation();
  const history = useHistory();
  const search = qs.parse(location.search, { ignoreQueryPrefix: true });
  const currentPage = +search.page || 1;
  const pageSize = +search.pageSize || 20;
  const onPaginationChange = (page) => {
    const newSearch = {
      ...search,
      page,
    };
    history.push({
      ...location,
      search: qs.stringify(newSearch),
    });
  };
  const onPageSizeChange = (pSize) => {
    const newSearch = {
      ...search,
      page: 1,
      pageSize: +pSize,
    };
    history.push({
      ...location,
      search: qs.stringify(newSearch),
    });
  };
  // Search
  const onSearchChange = (e) => {
    const newSearch = {
      ...search,
      q: e.target.value,
      page: 1,
    };
    history.push({
      ...location,
      search: qs.stringify(newSearch),
    });
  };
  // Filter
  const workspaceFilter = search.f || 'ALL';
  const onFilterChange = (f) => {
    const newSearch = {
      ...search,
      f,
    };
    history.push({
      ...location,
      search: qs.stringify(newSearch),
    });
  };
  // Data retrieving
  const [, app] = match.path.split('/');
  const isV2 = (APP[app]?.version || 1) >= 2;
  const statsKey = (w) => (isV2 ? w.moduleId : w.teamId);
  const teamIdKey = (w) => (isV2 ? w.platformTeamId : w.teamId);
  // V2 resolves its Module filter as its own query so the list and count share a
  // single resolution instead of each running the search lookups, and so paging
  // reuses it. Keyed without page/pageSize for exactly that reason.
  const { data: v2Filter } = useQuery(
    ['workspacesV2Filter', app, workspaceFilter, search.q],
    () => resolveWorkspacesV2Filter(app, workspaceFilter, search.q),
    { enabled: isV2 }
  );
  const isFilterReady = !isV2 || !!v2Filter;
  const {
    isLoading,
    data: workspaces,
    refetch: refetchList,
  } = useQuery(
    ['listWorkspaces', app, workspaceFilter, pageSize, currentPage, search.q],
    () => (isV2
      ? listWorkspacesV2(app, v2Filter, workspaceFilter, pageSize, currentPage)
      : listWorkspaces(app, workspaceFilter, pageSize, currentPage, search.q)),
    { enabled: isFilterReady }
  );
  const {
    data: count,
    isLoading: isCountLoading,
    refetch: refetchCount,
  } = useQuery(
    ['countWorkspaces', app, workspaceFilter, search.q],
    () => (isV2
      ? countWorkspacesV2(app, v2Filter)
      : countWorkspaces(app, workspaceFilter, search.q)),
    { enabled: isFilterReady }
  );
  const statsIds = (workspaces || []).map(statsKey);
  const { data: statsTmp } = useQuery({
    queryKey: ['getStats', app, statsIds.join(',')],
    queryFn: () => getStats(app, statsIds),
    enabled: !!workspaces,
  });
  const stats = statsTmp || {};
  // Actions
  const [action, setAction] = useState(null);
  const [isPerformingAction, setIsPerformingAction] = useState(false);
  const onPerformAction = async () => {
    try {
      setIsPerformingAction(true);
      if (action.type === 'FREE_FOREVER') {
        await grantFreePlan(app, action.workspace._id, action.workspace.workspaceId);
      } else if (action.type === 'DELETE') {
        await deleteWorkspace(app, action.workspace._id);
      } else {
        throw new Error(`Unknown action ${action.type}`);
      }
      message.success('Success');
      setAction(null);
      refetchList();
      refetchCount();
    } catch (error) {
      message.error('Unexpected error while performing action!');
    }
    setIsPerformingAction(false);
  };
  const onCopyPaymentLink = async (w) => {
    // eslint-disable-next-line no-promise-executor-return
    let paymentLink = `${process.env.API_URL}/subscribe/${app}/${w._id}`;
    if (app !== 'seed') {
      const tid = teamIdKey(w);
      const wsId = isV2 ? w.workspaceId : undefined;
      const seats = await countSeats(app, tid, wsId);
      if (isV2) {
        paymentLink = `https://buddieshr.com/upgrade?app=${app}`
          + `&workspaceId=${w.workspaceId}`
          + `&appUsersCount=${seats}`
          + `&totalUsersCount=${stats[statsKey(w)]?.usersCount}`;
      } else {
        paymentLink = `https://buddieshr.com/subscribe?app=${app}`
          + `&teamId=${tid}&workspaceId=${w._id}`
          + `&activeUsersCount=${seats}`
          + `&usersCount=${stats[statsKey(w)]?.usersCount}`;
      }
    }
    navigator.clipboard.writeText(paymentLink);
    message.success('Copied to clipboard');
  };
  return (
    <div id="Workspaces">
      <div className="Filters">
        <Select
          value={workspaceFilter}
          style={{ width: 180, marginRight: 8, marginBottom: 6 }}
          onChange={onFilterChange}
        >
          <Select.Option value="ALL">All</Select.Option>
          <Select.Option value="FREE_TRIAL">Free trials</Select.Option>
          <Select.Option value="CUSTOMER">All customers</Select.Option>
          {isV2 && <Select.Option value="DIRECT_CUSTOMER">Direct customers</Select.Option>}
          {isV2 && <Select.Option value="BUDDIES_CUSTOMER">Buddies customers</Select.Option>}
          {isV2 && <Select.Option value="FREE_FOREVER">Free forever</Select.Option>}
        </Select>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search"
          defaultValue={search.q || ''}
          style={{ width: 260, marginBottom: 6 }}
          onChange={debounce(onSearchChange, 500)}
          allowClear
        />
        {isV2 && (
          <Tooltip
            title={(
              <div style={{ lineHeight: 1.5 }}>
                <div>
                  <strong>Exact ID match</strong>
                  {' (24-hex):'}
                </div>
                <div>• workspaceId</div>
                <div>• moduleId</div>
                <div>• integrationId</div>
                <div style={{ marginTop: 6 }}>
                  <strong>Exact match</strong>
                  :
                </div>
                <div>• integration platform id (e.g. Slack team id)</div>
                <div style={{ marginTop: 6 }}>
                  <strong>Partial match</strong>
                  {' (case-insensitive):'}
                </div>
                <div>• workspace name</div>
                <div>• workspace domain</div>
              </div>
            )}
          >
            <InfoCircleOutlined style={{
              marginLeft: 8, marginBottom: 6, color: '#888', cursor: 'help',
            }}
            />
          </Tooltip>
        )}
        <div style={{ flex: 1 }} />
        <Select
          value={`${pageSize}`}
          style={{ width: 200, marginRight: 16, marginBottom: 6 }}
          onChange={onPageSizeChange}
        >
          {[20, 100, 500].map((n) => (
            <Select.Option value={`${n}`} key={n}>
              {`${n} per page`}
            </Select.Option>
          ))}
        </Select>
        <Pagination
          current={currentPage}
          onChange={onPaginationChange}
          total={count}
          pageSize={pageSize}
          showSizeChanger={false}
          style={{ marginBottom: 6 }}
        />
      </div>
      <Table
        dataSource={workspaces}
        loading={isLoading}
        pagination={false}
        rowKey="_id"
        size="small"
        scroll={{ x: 1500 }}
      >
        {isV2 ? (
          <Table.Column
            title={`Workspace ID (${isCountLoading ? '...' : count})`}
            dataIndex="workspaceId"
            key="_id"
            render={divMaxWidth()}
          />
        ) : (
          <Table.Column
            title={`Team ID (${isCountLoading ? '...' : count})`}
            dataIndex="teamId"
            render={divMaxWidth()}
          />
        )}
        {isV2 && (
          <Table.Column
            title="Module ID"
            dataIndex="moduleId"
            key="_id"
            render={divMaxWidth()}
          />
        )}
        {!isV2 && (
          <Table.Column
            title="Install User"
            dataIndex="installerUserId"
            key="_id"
            render={(userId, w) =>
              divMaxWidth()(
                <a href={`/#/${app}/users?q=${userId}&teamId=${teamIdKey(w)}`}>
                  {userId}
                </a>
              )
            }
          />
        )}
        <Table.Column
          title="Install Date"
          dataIndex="_id"
          render={(_, w) => {
            const d = moment(dateFromMongoId(w._id));
            return (
              <Tooltip title={d.format('YYYY-MM-DD @ HH:mm')}>
                <span style={{ whiteSpace: 'nowrap' }}>{d.format('YYYY-MM-DD')}</span>
              </Tooltip>
            );
          }}
        />
        <Table.Column
          title=""
          dataIndex="_id"
          key="_id"
          render={(_, w) => (
            <Tooltip title={APP[app].info(w, stats[statsKey(w)])}>
              {APP[app].status(w, stats[statsKey(w)])}
            </Tooltip>
          )}
        />
        <Table.Column
          title="Name"
          dataIndex="name"
          key="_id"
          render={(name) => divMaxWidth(300)(name || '-')}
        />
        <Table.Column
          title="Domain"
          dataIndex="domain"
          key="_id"
          render={(domain) => divMaxWidth(220)(domain || '-')}
        />
        {isV2 && (
          <Table.Column
            title="Int."
            key="_id"
            render={(_, w) => {
              const nonWeb = (w.integrations || []).filter((i) => i.type !== 'WEB');
              if (!nonWeb.length) return <span>—</span>;
              // Icons only — the platform id lives in the hover tooltip so the
              // column stays narrow. Uninstalled integrations are greyed out.
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {nonWeb.map((i) => {
                    const uninstalled = i.status !== 'ACTIVE';
                    return (
                      <Tooltip
                        key={i._id}
                        title={
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {i.platformTeamId || '?'}
                            {uninstalled && ' (uninstalled)'}
                            {i.platformTeamId && (
                              <CopyOutlined
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  navigator.clipboard.writeText(i.platformTeamId);
                                  message.success('Copied to clipboard');
                                }}
                              />
                            )}
                          </span>
                        }
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            cursor: 'pointer',
                            ...(uninstalled
                              ? { filter: 'grayscale(1)', opacity: 0.35 }
                              : {}),
                          }}
                        >
                          <PlatformLogo type={i.type} size={14} showTitle={false} />
                        </span>
                      </Tooltip>
                    );
                  })}
                </div>
              );
            }}
          />
        )}
        {isV2 && (
          <Table.Column
            title="Install User"
            dataIndex="installerUserId"
            key="_id"
            render={(userId, w) =>
              divMaxWidth()(
                w.installer ? (
                  <a
                    href={`/#/${app}/users?workspaceId=${w.workspaceId}&q=${encodeURIComponent(w.installer.email)}`}
                    title={w.installer.email}
                  >
                    {w.installer.name}
                  </a>
                ) : (
                  <span>{userId || '-'}</span>
                )
              )
            }
          />
        )}
        {!isV2 && <Table.Column title="Lang" dataIndex="lang" key="_id" />}
        <Table.Column
          title={isV2 ? (
            <span style={{ whiteSpace: 'nowrap' }}>
              Origin
              <Tooltip
                title={(
                  <div>
                    <div>
                      <strong>discoverySource / ref</strong>
                    </div>
                    <div>• discoverySource: how the user says they found us</div>
                    <div>• ref: set programmatically (sometimes wrong)</div>
                    <div>• - means the value is empty</div>
                  </div>
                )}
              >
                <InfoCircleOutlined style={{ marginLeft: 6, color: '#888', cursor: 'help' }} />
              </Tooltip>
            </span>
          ) : 'Origin'}
          dataIndex={isV2 ? 'ref' : 'state'}
          key="_id"
          render={(o, w) => {
            const origin = isV2
              ? `${w.discoverySource || '-'} / ${o || '-'}`
              : o || '';
            const text = `${origin}${w.gclid ? ' + gclid' : ''}`;
            return (
              <Tooltip title={text}>
                {divMaxWidth(160)(text)}
              </Tooltip>
            );
          }}
        />
        {APP[app].columns.map((column) => (
          <Table.Column
            title={column.title}
            key="_id"
            render={(_, w) => (
              <div style={{ whiteSpace: 'nowrap' }}>
                {column.render(w, stats[statsKey(w)])}
              </div>
            )}
          />
        ))}
        <Table.Column
          title="⚔️"
          key="_id"
          render={(_, w) => {
            const sk = statsKey(w);
            if (!stats[sk]?.competitors?.length) return '-';
            return (
              <div style={{ whiteSpace: 'nowrap' }}>
                {stats[sk].competitors.map((c) => (
                  <img
                    src={COMPETITOR[c.name]?.img}
                    alt={c.name}
                    title={c.name}
                    key={c.name}
                    style={{
                      width: 18,
                      borderRadius: 18,
                      marginRight: 4,
                      ...(c.deleted
                        ? {
                          filter: 'grayscale(1)',
                          opacity: 0.3,
                        }
                        : {}),
                    }}
                  />
                ))}
              </div>
            );
          }}
        />
        <Table.Column
          title="💰"
          key="_id"
          render={(_, w) =>
            w.freeTrialStartDate ? (
              <Tooltip title={w.freePlanUsersLimit ? `Free plan: ${w.freePlanUsersLimit}` : null}>
                <span
                  style={{
                    whiteSpace: 'nowrap',
                    color: moment(w.freeTrialStartDate).isBefore(
                      moment().subtract(30, 'days')
                    )
                      ? 'red'
                      : undefined,
                  }}
                >
                {moment(w.freeTrialStartDate).format('YYYY-MM-DD')}
                {w.initialFreeTrialStartDate ? (
                  <Tooltip title={`Initial=${moment(w.initialFreeTrialStartDate).format('YYYY-MM-DD')}`} placement="bottom">
                    {' 🔄'}
                  </Tooltip>
                ) : ''}
                </span>
              </Tooltip>
            ) : w.stripeSubscription ? (
              <span style={{ whiteSpace: 'nowrap' }}>
                🤑
                {subscriptionCancelAt(w.stripeSubscription) && (
                  <CancelingSign cancelAt={subscriptionCancelAt(w.stripeSubscription)} />
                )}
              </span>
            ) : w.buddiesSubscription ? (
              <span style={{ whiteSpace: 'nowrap' }}>
                👯‍♂️
                {w.buddiesSubscriptionCancelAt && (
                  <CancelingSign cancelAt={w.buddiesSubscriptionCancelAt} />
                )}
              </span>
            ) : w.freeForever ? (
              '♾️'
            ) : (
              '-'
            )
          }
        />
        {isV2 && (
          <Table.Column
            title="🪑"
            key="_id"
            render={(_, w) => {
              const sk = statsKey(w);
              return stats[sk]?.seatsCount || '-';
            }}
          />
        )}
        <Table.Column
          title=""
          key="_id"
          render={(_, w) => {
            const sk = statsKey(w);
            const href = isV2
              ? `#/${app}/users?workspaceId=${w.workspaceId}`
              : `#/${app}/users?teamId=${teamIdKey(w)}`;
            return (
              <a href={href} style={{ whiteSpace: 'nowrap' }}>
                {`View users${
                  stats[sk] ? ` (${stats[sk].usersCount})` : ''
                }`}
              </a>
            );
          }}
        />
        <Table.Column
          title=""
          key="_id"
          render={(_, w) => (
            <div>
              <Dropdown
                trigger="click"
                overlay={
                  <Menu>
                    {!isV2 && (
                      <Menu.Item
                        danger
                        onClick={() =>
                          setAction({ type: 'DELETE', workspace: w })
                        }
                      >
                        <DeleteOutlined />
                        {' Delete'}
                      </Menu.Item>
                    )}
                    {!isV2 && w.stripeCustomer && (
                      <Menu.Item
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${process.env.API_URL}/customer-portal/${app}/${w.encryptedId}`
                          );
                          message.success('Copied to clipboard');
                        }}
                      >
                        <UserOutlined />
                        {' Customer Portal'}
                      </Menu.Item>
                    )}
                    {w.freeTrialStartDate && (
                      <Menu.Item
                        onClick={() => onCopyPaymentLink(w)}
                      >
                        <DollarOutlined />
                        {' Payment Link'}
                      </Menu.Item>
                    )}
                    {!w.freeForever &&
                      !w.stripeSubscription &&
                      !w.buddiesSubscription && (
                        <Menu.Item
                          onClick={() =>
                            setAction({ type: 'FREE_FOREVER', workspace: w })
                          }
                        >
                          <CrownOutlined />
                          {' Grant Free Forever'}
                        </Menu.Item>
                      )}
                  </Menu>
                }
              >
                <div style={{ cursor: 'pointer' }}>
                  <MoreOutlined />
                </div>
              </Dropdown>
            </div>
          )}
        />
      </Table>
      {action && (
        <ConfirmModal
          strConfirm={action ? action.workspace.name : ''}
          onSubmit={onPerformAction}
          onCancel={() => setAction(null)}
          loading={isPerformingAction}
          title={action ? `Confirm ${action.type}` : ''}
        />
      )}
    </div>
  );
}

Workspaces.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object.isRequired,
};

export default Workspaces;
